import { render } from "./Usuarios.vue?vue&type=template&id=b8e37c00&scoped=true"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"

import "./Usuarios.vue?vue&type=style&index=0&id=b8e37c00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e37c00"]])

export default __exports__